export const equipmentCheckKeys = {
    all: () => ['equipment-checks'] as const,
    exceptions: (yardId: string | null) => ['equipment-checks', 'exceptions', yardId] as const,
    waitingForUnitNumbers: (yardId: string | null) =>
        ['equipment-checks', 'waiting-for-unit-numbers', yardId] as const,
}
